import { apiFetch } from "./client.ts";

export interface LoginResponse {
  token: string;
  expiresAt: string;
  user: {
    id: string;
    email: string;
    name: string;
    role: string;
  };
}

export interface MeResponse {
  id: string;
  email: string;
  name: string;
  role: string;
  mfaEnabled: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  return apiFetch<LoginResponse>("/api/v1/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export async function logout(token: string): Promise<void> {
  await apiFetch<{ message: string }>("/api/v1/auth/logout", {
    method: "POST",
    token,
  });
}

export async function getMe(token: string): Promise<MeResponse> {
  return apiFetch<MeResponse>("/api/v1/auth/me", { token });
}
